import SupplierPageImg1 from "../../assets/images/SupplierPageImg1.svg";
import SupplierPageImg2 from "../../assets/images/SupplierPageImg2.svg";
import product1 from "../../assets/images/SupplierProduct1.svg";
import product2 from "../../assets/images/SupplierProduct2.svg";
import product3 from "../../assets/images/SupplierProduct3.svg";
import product4 from "../../assets/images/SupplierProduct4.svg";
import product5 from "../../assets/images/SupplierProduct5.svg";
import product6 from "../../assets/images/SupplierProduct6.svg";
import product7 from "../../assets/images/SupplierProduct7.svg";
import product8 from "../../assets/images/SupplierProduct8.svg";
import product9 from "../../assets/images/SupplierProduct9.svg";
import product10 from "../../assets/images/SupplierProduct10.svg";
import product11 from "../../assets/images/SupplierProduct11.svg";
import product12 from "../../assets/images/SupplierProduct12.svg";
import { FaSearch } from "react-icons/fa";
import { IoIosHeartEmpty } from "react-icons/io";
import { IoHeart } from "react-icons/io5";
import { FaPlus } from "react-icons/fa";
import React, { useState, useCallback, useMemo } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { calculateDiscountedPrice, renderStars } from "../../utils/functions";
import debounce from "lodash/debounce";
import { useUser } from "../../context/UserContext";
import { useCurrency } from "../../context/CurrencyContext";
import { useLanguage } from "../../context/LanguageContext";

const SupplierPage = () => {
  const {t} = useLanguage();
  const { exchangeRate } = useCurrency();
  const [activeTab, setActiveTab] = useState("accountSettings");
  const [searchTerm, setSearchTerm] = useState("");
  const { user } = useUser();

  const [likedProducts, setLikedProducts] = useState<{
    [key: number]: boolean;
  }>({});
  const [clickedProduct, setClickedProduct] = useState<number | null>(null);

  const products = [
    {
      id: 1,
      name: "Canbebe Bebek Bezi",
      price: 120,
      discount: 0,
      rating: 4.5,
      image: product1,
    },
    {
      id: 2,
      name: "Canbebe Bebek Bezi",
      price: 260,
      discount: 20,
      rating: 3.5,
      image: product2,
    },
    {
      id: 3,
      name: "Baby Me Süt Saklama Poşeti",
      price: 180,
      discount: 0,
      rating: 4.5,
      image: product3,
    },
    {
      id: 4,
      name: "Kotex Ultra Ped Normal",
      price: 160,
      discount: 30,
      rating: 4.5,
      image: product4,
    },
    {
      id: 5,
      name: "Canbebe Bebek Bezi",
      price: 120,
      discount: 0,
      rating: 4.5,
      image: product5,
    },
    {
      id: 6,
      name: "Canbebe Bebek Bezi",
      price: 260,
      discount: 20,
      rating: 3.5,
      image: product6,
    },
    {
      id: 7,
      name: "Baby Me Süt Saklama Poşeti",
      price: 180,
      discount: 0,
      rating: 4.5,
      image: product7,
    },
    {
      id: 8,
      name: "Kotex Ultra Ped Normal",
      price: 160,
      discount: 30,
      rating: 4.5,
      image: product8,
    },
    {
      id: 9,
      name: "Canbebe Bebek Bezi",
      price: 120,
      discount: 0,
      rating: 1,
      image: product9,
    },
    {
      id: 10,
      name: "Canbebe Bebek Bezi",
      price: 260,
      discount: 20,
      rating: 1,
      image: product10,
    },
    {
      id: 11,
      name: "Baby Me Süt Saklama Poşeti",
      price: 180,
      discount: 0,
      rating: 1,
      image: product11,
    },
    {
      id: 12,
      name: "Kotex Ultra Ped Normal",
      price: 160,
      discount: 30,
      rating: 1,
      image: product12,
    },
  ];

  const toggleLike = (id: number, productName: string) => {
    if (!user) {
      toast.error(t('toastMessage', 'addBasketFavErr'));
      return;
  }
    setLikedProducts((prevLikedProducts) => {
      
      const isLiked = !prevLikedProducts[id];
      if (isLiked) {
        toast.success(`${productName} ${t('toastMessage', 'addBasketFavSuc')}`);
      } else {
        toast.info(`${productName} ${t('toastMessage', 'addBasketFavInfo')}`);
      }
      return {
        ...prevLikedProducts,
        [id]: isLiked,
      };
    });
  };

  const handleAddToCart = (productId: number, productName: string) => {
    setClickedProduct(productId);
    toast.success(`${productName} ${t('toastMessage', 'addBasketCartSuc')}`);
    setTimeout(() => {
      setClickedProduct(null);
    }, 1000);
  };

  const handleTabChange = (tab: string) => {
    setActiveTab(tab);
  };

  const debouncedSearch = useCallback(
    debounce((searchValue: string) => {
      setSearchTerm(searchValue);
    }, 500),
    []
  );

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    debouncedSearch(event.target.value);
  };

  const filteredProducts = useMemo(() => {
    return products.filter((product) =>
      product.name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [products, searchTerm]);

  return (
    <main>
      {/* <Header />
      <Navbar /> */}
      <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
      {/* Top image and Search Bar */}
      <div className="mb-5 md:flex-row md:flex items-center">
        <div className="md:w-3/5 md:ml-8 justify-center md:justify-start flex">
          <img src={SupplierPageImg1} alt="Supplier Page Img1" />
        </div>
        <div className="flex md:w-2/5 md:justify-start justify-center">
          <div className="relative" style={{ width: "23rem" }}>
            <FaSearch className="absolute left-2 top-1/2 transform -translate-y-1/2 text-primary-color" />
            <input
              type="text"
              placeholder="Mağazada Ara"
              className="pl-10 w-full py-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-color bg-color-searchbar shadow-xl border-t border-color-lighter-gray"
              onChange={handleSearchChange}
            />
          </div>
        </div>
      </div>

      <img src={SupplierPageImg2} alt="Supplier Page Img2" className="w-full" />

      {/* Middle Menu */}

      <div className="flex flex-row items-center mb-10 mt-8 p-2 md:text-xl justify-between bg-white shadow-lg border-t border-color-lighter-gray  text-gray-500 text-center md:w-5/6 mx-auto">
        <button
          onClick={() => handleTabChange("lastProduct")}
          className={`w-1/3 ${
            activeTab === "lastProduct"
              ? "font-semibold text-primary-color underline underline-offset-4	  border-primary-color"
              : "text-color-opacity "
          }`}
        >
          Son Ürünler
        </button>
        <button
          onClick={() => handleTabChange("promotional")}
          className={`w-1/3 ${
            activeTab === "promotional"
              ? "font-semibold text-primary-color underline underline-offset-4 border-primary-color"
              : "text-color-opacity "
          }`}
        >
          Promosyon Ürünleri
        </button>
        <button
          onClick={() => handleTabChange("discountProduct")}
          className={`w-1/3 ${
            activeTab === "discountProduct"
              ? "font-semibold text-primary-color underline  underline-offset-4 border-primary-color"
              : "text-color-opacity "
          }`}
        >
          İndirimli Ürünler
        </button>
      </div>

      {/*Products*/}

      <section className="flex flex-wrap items-center justify-center mb-24">
        {filteredProducts.map((product) => (
          <div>
            <div key={product.id} className=" w-64 lg:w-80 h-full p-4">
              <div className="h-full flex flex-col justify-between overflow-hidden">
                <div className="w-full flex justify-center rounded-lg relative py-6 bg-color-product-bg">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="h-64 object-cover rounded-t-lg"
                  />
                  <button
                    className="absolute top-2 right-2 rounded-full bg-transparent"
                    onClick={() => toggleLike(product.id, product.name)}
                  >
                    {likedProducts[product.id] ? (
                      <IoHeart className="text-yellow-300 text-3xl mt-2 mr-2" />
                    ) : (
                      <IoIosHeartEmpty className="text-yellow-300 text-3xl mt-2 mr-2" />
                    )}
                  </button>
                </div>
                <div className="p-4 flex flex-col justify-between flex-grow">
                  <h2 className="text-lg font-bold truncate">{product.name}</h2>
                  <div className="flex items-center mt-2">
                    <div className="flex items-center">
                      {renderStars(product.rating)}
                    </div>
                  </div>
                  <div className="w-full mt-4 flex justify-between items-end">
                    <div className="flex gap-2 items-center">
                      {product.discount > 0 ? (
                        <>
                          <p className="text-lg lg:text-2xl font-semibold ">
                            ₺
                            {calculateDiscountedPrice(
                              product.price,
                              product.discount,
                              0,
                              exchangeRate
                            )}
                          </p>
                          <p className="text-sm lg:text-2xl font-semibold line-through text-gray-500">
                            ₺{product.price}
                          </p>
                        </>
                      ) : (
                        <p className="text-lg lg:text-2xl font-semibold">
                          ₺{product.price}
                        </p>
                      )}
                      <div className="w-12 h-8 flex items-center justify-center text-sm bg-red-200 text-red-700 px-4 rounded-3xl">
                        {product.discount}%
                      </div>
                    </div>
                    <button
                      className={`text-white text-lg md:text-2xl font-bold p-2 rounded-full shadow-md ${
                        clickedProduct === product.id
                          ? "bg-green-500"
                          : "bg-primary-color"
                      }`}
                      onClick={() => handleAddToCart(product.id, product.name)}
                    >
                      <FaPlus />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="border-t border-gray-300 mx-auto mt-16 w-full"></div>
          </div>
        ))}
      </section>

      {/* <Footer /> */}
    </main>
  );
};

export default SupplierPage;
